import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { STATUSES } from '../data/config';

const StatusWidget = () => {
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex(i => (i + 1) % STATUSES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div className="status-widget">
      <AnimatePresence mode="wait">
        <motion.div
          key={statusIndex}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="status-content"
        >
          <span className="status-label">{STATUSES[statusIndex].label}:</span>
          <span className="status-value">{STATUSES[statusIndex].value}</span>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default StatusWidget;
